import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";

import "./App.css";
import { PulseFitnessPage } from "./components/PulseFitnessPage";
import { TrainerDirectoryPage } from "./components/TrainerDirectoryPage";
import { UmairAnsariPage } from "./components/UmairAnsariPage";
import { Toaster } from "./components/ui/sonner";

const HashScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const targetId = location.hash.replace("#", "");

    const scrollToHashTarget = (retries = 12) => {
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      if (retries > 0) {
        window.setTimeout(() => scrollToHashTarget(retries - 1), 120);
      }
    };

    window.setTimeout(() => scrollToHashTarget(), 120);
  }, [location.pathname, location.hash]);

  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      smoothWheel: true,
      wheelMultiplier: 0.95,
      touchMultiplier: 1.1,
    });

    let frameId = 0;

    const raf = (time) => {
      lenis.raf(time);
      frameId = requestAnimationFrame(raf);
    };

    frameId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(frameId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <HashScrollHandler />
        <Routes>
          <Route element={<PulseFitnessPage />} path="/" />
          <Route element={<TrainerDirectoryPage />} path="/coaches" />
          <Route element={<UmairAnsariPage />} path="/coaches/umair-ansari" />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
